import { z } from 'zod';

export const dateSchema = z.preprocess((argument) => {
  if (typeof argument === 'string' || argument instanceof Date) {
    return new Date(argument);
  }
  return argument;
}, z.date());

export type DateSchema = z.infer<typeof dateSchema>;

export const dateOnlySchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be in ISO format (YYYY-MM-DD)');
